import { Provider } from '@angular/core';
import { AUTH_SERVICE, TOKEN_SERVICE } from '@core/tokens/auth.tokens';
import { AuthService } from '@domains/auth/services/auth.service';
import { TokenService } from '@domains/auth/services/token.service';

/**
 * Registra los servicios de autenticación en la aplicación.
 *
 * Quitar esta llamada de app.config.ts desactiva completamente
 * el sistema de autenticación sin romper la aplicación.
 *
 * @example
 * ```typescript
 * // app.config.ts
 * providers: [
 *   ...provideAuth(),
 * ]
 * ```
 */
export function provideAuth(): Provider[] {
  return [
    { provide: AUTH_SERVICE, useExisting: AuthService },
    { provide: TOKEN_SERVICE, useExisting: TokenService },
  ];
}
